<template>
  <tr>
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>

    <td>
      <router-link
        :to="{
          name: 'draft-order-saved',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.id.split('-')[0] }}
      </router-link>
    </td>
    <td>
      <router-link
        v-if="props.item.customer.customer_id"
        :to="{
          name: 'single_customer',
          params: { id: props.item.customer.customer_id }
        }"
        :color="props.item.status | orderStatusColor"
      >
        {{ props.item.customer.firstname }}
        {{ props.item.customer.lastname }}
      </router-link>
      <template v-else>
        {{ props.item.customer.firstname }}
        {{ props.item.customer.lastname }}
      </template>

    </td>
    <td>
      {{ props.item.summary.total_items_count }}
    </td>
    <td>{{ props.item.summary.total_due | money }}</td>
    <td>{{ props.item.created_by ? props.item.created_by.name : '' }}</td>
    <td>{{ props.item.created_by ? props.item.created_by.from : '' }}</td>
    <td>{{ props.item.created_at | timezone }}</td>
  </tr>
</template>
<script>
export default {
  name: 'QuoteDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
